import React, { useRef } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Services from './components/Services';
import AboutUs from './components/AboutUs';
import Projects from './components/Projects';
import Choose from './components/Choose';
import TeamSection from './components/TeamSection';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';

function App() {
  const footerRef = useRef(null);

  return (
    <div>
      <Header />
      <HeroSection />
      <AboutUs />
      <Services />
      <Choose />
      <Projects />
      <TeamSection />
      <Testimonials />
      <Contact />
      <Footer ref={footerRef} />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
